import { Observable } from 'rxjs/internal/Observable';
import { AgTextAreaEditor, idNameItem, jkLib, jkRestReturn } from 'jk-service';
import { Injectable } from '@angular/core';
import { AxiosRequestConfig } from 'axios';
import { StklgServicePkg } from './stklgPkg.service';
import { Stklg } from '../entity/Stklg-angular';

export const stklg002List: idNameItem[] = [
  { id: '0001', name: '0001:1分鐘' },
  { id: '0005', name: '0005:5分鐘' },
  { id: '0015', name: '0015:15分鐘' },
  { id: '0030', name: '0030:30分鐘' },
  { id: '0060', name: '0060:60分鐘' },
  { id: '日線', name: '日線' },
  { id: '周線', name: '周線' },
  { id: '月線', name: '月線' },
  { id: '季線', name: '季線' },
]; // 0001 0005 0030 0060  日線 月線 周線

export const stklg039List: idNameItem[] = [
  { id: '', name: '全部' },
  { id: '1', name: '向上' },
  { id: '-1', name: '向下' },
]; //

export const stockRangeList: idNameItem[] = [
  { id: '1', name: '1天' },
  { id: '5', name: '1周' },
  { id: '10', name: '雙周' },
  { id: '20', name: '1月' },
  { id: '60', name: '1季' },
  { id: '120', name: '半年' },
  { id: '240', name: '1年' },
  { id: 'd', name: '今天' },
  { id: 'w', name: '本周' },
  { id: 'm', name: '本月' },
  { id: 's', name: '本季' },
  { id: 'y', name: '今年' },
];

export const stklgOrderList: idNameItem[] = [{ 'id': 'ORDER BY LG001,LG002,LG003,LG004', 'name': '日期順序' },
{ 'id': 'ORDER BY LG001 DESC,LG002 DESC,LG003 DESC,LG004 DESC', 'name': '日期倒序' }];

export interface StklgRange {
  stockNos: string,
  date1: string,
  date2: string,
  time1: string,
  time2: string,
  period: string, // lg002
  rangeId: string,
  topN: number,
};


@Injectable({
  providedIn: 'root',
})
export class StklgService extends StklgServicePkg { // <Stklg>
  //0001 0005 0030 0060  日線 月線 周線
  constructor() {
    super();

    this.sqlSelect = 'SELECT TOP 300 *  FROM STKLG';
    /*
    this.columnDefs = [
      { field: "LG001", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: (p:any) => { return jkLib.dateField2Display(p.value)},  },
      { field: "LG002", headerName: "周期(分)",headerTooltip: "",width:102,cellDataType: "text", },
      { field: "LG003", headerName: "時間",headerTooltip: "",width:134,cellDataType: "text", },
      { field: "LG004", headerName: "商品代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "LG005", headerName: "成交張數",headerTooltip: "",width:158,cellDataType: "number", },
      { field: "LG006", headerName: "成交量",headerTooltip: "",width:158,cellDataType: "number", },
      { field: "LG007", headerName: "開盤價",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG008", headerName: "最高價",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG009", headerName: "最低價",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG010", headerName: "收盤價",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG011", headerName: "昨收價",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG012", headerName: "更新時間",headerTooltip: "",width:80,cellDataType: "date", },
      { field: "LG013", headerName: "操盤分析",headerTooltip: "",width:250,cellDataType: "text", cellRenderer: AgTextAreaEditor,  },
      { field: "LG014", headerName: "BBand上軌",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG015", headerName: "BBand下軌",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG016", headerName: "B指標",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG017", headerName: "BBAND帶寬",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG018", headerName: "BBAND_BW",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG019", headerName: "MACD",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG020", headerName: "DIF",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG021", headerName: "OSC",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG022", headerName: "振幅%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG023", headerName: "漲跌幅%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG024", headerName: "漲跌",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG025", headerName: "SMA5",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG026", headerName: "SMA10",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG027", headerName: "SMA20",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG028", headerName: "SMA60",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG029", headerName: "K(9,3)",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG030", headerName: "D(9,3)",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG031", headerName: "買賣評分",headerTooltip: "",width:102,cellDataType: "number", },
      { field: "LG032", headerName: "週漲%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG033", headerName: "月漲%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG034", headerName: "季漲%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG035", headerName: "成交量增減%",headerTooltip: "",width:152,cellDataType: "number", },
      { field: "LG036", headerName: "SMA5-方向",headerTooltip: "",width:94,cellDataType: "number", },
      { field: "LG037", headerName: "SMA10-方向",headerTooltip: "",width:94,cellDataType: "number", },
      { field: "LG038", headerName: "SMA20-方向",headerTooltip: "",width:94,cellDataType: "number", },
      { field: "LG039", headerName: "SMA60-方向",headerTooltip: "",width:94,cellDataType: "number", },
      { field: "LG040", headerName: "狀態",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "LG041", headerName: "K線型態",headerTooltip: "",width:250,cellDataType: "text", cellRenderer: AgTextAreaEditor,  },
      { field: "LG042", headerName: "最新一筆成交價格",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG043", headerName: "離5SMA%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG044", headerName: "離10SMA%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG045", headerName: "離20SMA%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG046", headerName: "離60SMA%",headerTooltip: "",width:137,cellDataType: "number", },
      { field: "LG047", headerName: "MA5",headerTooltip: "",width:160,cellDataType: "number", },
      { field: "LG048", headerName: "MA10",headerTooltip: "",width:160,cellDataType: "number", },];
       */
  }
  /* 只重算 stklg 日期區間的資料
  */
  async doCalcRange(
    stockNos: string,
    date2: string,
    lg002: string,
    topN: number,
    xTime: string,
    ret: jkRestReturn
  ) {
    let data = {
      stockNos: stockNos,
      date2: date2,
      kinds: '',
      period: lg002,
      topN: topN,
      time0: xTime,
    };
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      '/stock/calc_range',
      'post',
      '',
      data
    );

    let bool = await this.doAxios(config, ret);
  }
  async doCalcOneday(
    stockNos: string,
    date1: string,
    date2: string,
    lg002: string,
    topN: number,
    ret: jkRestReturn
  ) {
    let data = {
      stockno: stockNos,
      date1: date1,
      date2: date2,
      kinds: '',
      period: lg002,
      topN: topN,
    };
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      '/stock/calc_oneday',
      'post',
      '',
      data
    );

    let bool = await this.doAxios(config, ret);
  }
  doStockQuery() {
    this.makeFilterOpt();
  }
  checkColor(close: number): string {
    let s = '';
    let s_number_white = ` style="
      border: 1px solid #ddd;
      text-align: right;
      color:white;
      width:70px;
        "`;
    let s_number_red = ` style="
      border: 1px solid #ddd;
      text-align: right;
      color:red;
      width:70px;
        "`;
    let s_number_green = ` style="
      border: 1px solid #ddd;
      text-align: right;
      color:green;
      width:70px;
        "`;
    if (close > 0) {
      s = s_number_red;
    } else if (close < 0) {
      s = s_number_green;
    } else {
      s = s_number_white;
    }
    return s;
  }
  DrawHtml(data: any, format: number = 1): string {
    let s = '';
    let s_label = ` style="
      border: 1px solid #ddd;
      width:80px;
      text-align: left;
      color: #ddd;
    "`;
    //let s1 = data.datetime1.toString();//jkLib.date2Display(data.LG001, '/') + '-' + data.LG003;
    if (format === 1) {
      s = `
      <table style="border-collapse: collapse;background-color: black;">
        <tr>
        <td ${s_label}>日期</td>
        <td ${this.checkColor(0)}>${data.FormattedDate}</td>
        <td ${s_label}>時間</td>
          <td ${this.checkColor(0)}>${data.FormattedTime}</td>
        </tr>
        <tr>
          <td ${s_label}>成交</td>
          <td ${this.checkColor(data.close)} >${data.close}</td>
          <td ${s_label}>漲跌</td>
          <td ${this.checkColor(data.updown)} >${data.updown}</td>
        </tr>
        <tr>
          <td ${s_label}>漲跌幅</td>
          <td ${this.checkColor(data.updown)} >${data.updown}</td>
          <td ${s_label}>總量</td>
          <td ${this.checkColor(data.qty)} >${data.qty}</td>
        </tr>
      </table>
        `;
    }
    if (format === 2) {
      s =
        '時間:' +
        data.time1 +
        '開盤: ' +
        data.open +
        ',收盤: ' +
        data.close +
        ',最高: ' +
        data.high +
        ',最低: ' +
        data.low +
        ',上軌: ' +
        data.UBT +
        ',下軌: ' +
        data.LBT +
        ',sma20: ' +
        data.sma20 +
        ',sma60: ' +
        data.sma60 +
        ',振幅:' +
        data.LG022 +
        '%,漲跌幅:' +
        data.LG023 +
        '%';
    }
    return s;
  }
  async calcStklgRange(range: StklgRange): Promise<StklgRange> {
    //let r: StklgRange = { stockNos: '', date1: '', date2: '', time1: '', time2: '', period: '', topN: 0 };
    // 算 date1,time1,topN
    let n = 1;
    switch (range.rangeId) {
      case 'd':
        n = 1;
        range.date1 = range.date2;
        break;
      case 'w':
        n = 5;
        // let w = jkLib.getWeekDate(range.date2); FIXME:
        break;
      case 'm':
        n = 20;
        break;
      case 's':
        n = 60;
        break;
      case 'y':
        n = 240;
        break;
      case '1':
        n = 1;
        break;
      case '5':
        n = 5;
        break;
      case '10':
        n = 10;
        break;
      case '20':
        n = 20;
        break;
      case '60':
        n = 60;
        break;
      case '120':
        n = 120;
        break;
      case '240':
        n = 240;
        break;
      default:
        n = 1;
        break;
    }
    range.topN = n;
    return range;
  }
  async getLastDay(): Promise<string> {
    const sql = `SELECT TOP 1 LG001 FROM STKLG ORDER BY LG001 DESC `;
    const ds: any[] = await this.jkBDb.simpleSql(sql);
    if (ds && ds.length > 0) {
      return ds[0].LG001;
    } else {
      return this.nowDate();
    }
  }
  getDay(date: string, stockno: string): Observable<Stklg[]> {
    let sql = `SELECT TOP 1 * FROM STKLG WHERE LG001<='${date}' AND LG002='日線' AND LG003='0000' AND LG004='${stockno}' ORDER BY LG001 DESC `;
    return this.simpleSqlRx(sql);
  }
}
